import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['row', 'header', 'indicator', 'container'];
  currentSortColumn = null;
  currentSortDirection = null;

  connect() {
    this.headerTargets.forEach((header) => {
      header.addEventListener('click', this.handleSortClick.bind(this));
    });
  }

  parseCompletionRate(rateStr) {
    if (!rateStr) return 0.0;
    try {
      return parseFloat(rateStr.toString().replace(/%$/, ''));
    } catch (e) {
      return 0.0;
    }
  }

  getSortValue(row, column) {
    switch (column) {
      case 'reward':
        return row.getAttribute('data-reward-name') || '';
      case 'brand':
        return row.getAttribute('data-brand-name') || '';
      case 'completed':
        return parseInt(row.getAttribute('data-completed') || '0', 10);
      case 'started':
        return parseInt(row.getAttribute('data-started') || '0', 10);
      case 'completion-rate':
        return this.parseCompletionRate(row.getAttribute('data-completion-rate') || '0');
      case 'status':
        return parseInt(row.getAttribute('data-status') || '0', 10);
      default:
        return '';
    }
  }

  sortTable(column, direction) {
    const rowsArray = Array.from(this.rowTargets);
    const container = this.containerTarget;
    if (!container) return;

    rowsArray.sort((a, b) => {
      const aVal = this.getSortValue(a, column);
      const bVal = this.getSortValue(b, column);

      let comparison = 0;
      if (aVal < bVal) {
        comparison = -1;
      } else if (aVal > bVal) {
        comparison = 1;
      }

      return direction === 'asc' ? comparison : -comparison;
    });

    rowsArray.forEach((row) => {
      container.appendChild(row);
    });
  }

  updateSortIndicators(column, direction) {
    this.headerTargets.forEach((header) => {
      const indicator = header.querySelector('.sort-indicator');
      const headerColumn = header.getAttribute('data-sort-column');

      if (headerColumn === column && indicator) {
        indicator.style.display = 'inline-block';
        const icon = indicator.querySelector('svg');
        if (!icon) {
          indicator.innerHTML =
            '<svg viewBox="0 0 32 32" class="w-4 h-4 flex-shrink-0" style="' +
            (direction === 'desc' ? 'transform: rotate(180deg);' : '') +
            '"><path d="M12.8 22.7C13.175 23.1 13.825 23.1 14.2 22.7L20.2 16.7C20.6 16.325 20.6 15.675 20.2 15.3L14.2 9.3C13.825 8.9 13.175 8.9 12.8 9.3C12.4 9.675 12.4 10.325 12.8 10.7L18.075 16L12.8 21.3C12.4 21.675 12.4 22.325 12.8 22.7Z"></path></svg>';
        } else {
          icon.style.transform = direction === 'desc' ? 'rotate(180deg)' : '';
        }
      } else if (indicator) {
        indicator.style.display = 'none';
      }
    });
  }

  handleSortClick(event) {
    const header = event.currentTarget;
    const column = header.getAttribute('data-sort-column');

    if (this.currentSortColumn === column && this.currentSortDirection === 'asc') {
      this.currentSortDirection = 'desc';
    } else {
      this.currentSortDirection = 'asc';
    }

    this.currentSortColumn = column;
    this.sortTable(column, this.currentSortDirection);
    this.updateSortIndicators(column, this.currentSortDirection);
  }
}
